<template>
  <div class="stage-column">
    <div class="stage-header">
      <p class="stageName">
        {{ stage.name }}
      </p>
      <div>
        <font-awesome-icon
          :icon="faArrowsAlt"
          class="stage-handle"
          title="Arraste para mover a coluna"
        />
        <b-dropdown
          size="sm"
          variant="link"
          no-caret
        >
          <template #button-content>
            <font-awesome-icon
              :icon="faPen"
              title="Ações da etapa"
            />
          </template>
          <b-dropdown-item @click="deletarEtapa(stage)">
            Excluir etapa
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div
      class="stage-color-bar"
      :style="{ backgroundColor: stage.color || '#ccc' }"
    />

    <draggable
      :list="stage.deals"
      v-bind="dragOptions"
      group="deals-group"
      tag="div"
      class="stage-deals-container"
      @start="onDragStart"
      @end="onDragEnd"
      @change="onDealChange"
    >
      <transition-group
        type="transition"
        :name="draggingCards ? null : 'card-reorder'"
      >
        <div
          v-for="(deal, cardIndex) in stage.deals"
          :key="cardIndex"
        >
          <oportunidade-card
            :deal="deal"
            @open="onCardClick(deal)"
          />
        </div>

        <div
          v-if="!stage.deals || stage.deals.length === 0"
          key="empty"
          class="empty-drop-zone"
        >
          <font-awesome-icon :icon="faArrowUp" />
          <p>Arraste um card aqui</p>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowUp, faArrowsAlt, faPen } from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'
import OportunidadeCard from './OportunidadeCard.vue'

export default {
  name: 'StageColumn',
  components: {
    draggable,
    FontAwesomeIcon,
    OportunidadeCard,
  },
  props: {
    stage: {
      type: Object,
      required: true,
    },
    dragOptions: {
      type: Object,
      required: true,
    },
  },
  emits: ['deal-changed', 'open-deal', 'delete-stage', 'drag-state-change'],
  data() {
    return {
      draggingCards: false,
      faArrowUp,
      faArrowsAlt,
      faPen,
    }
  },
  methods: {
    onDealChange(event) {
      this.$emit('deal-changed', { stage: this.stage, event })
    },
    onCardClick(deal) {
      if (this.draggingCards) return
      this.$emit('open-deal', deal)
    },
    onDragStart() {
      this.draggingCards = true
      this.$emit('drag-state-change', true)
    },
    onDragEnd() {
      this.draggingCards = false
      this.$emit('drag-state-change', false)
    },
    deletarEtapa(stage) {
      this.$confirmar(
        'Deseja realmente excluir esta etapa?',
        'Essa ação não pode ser desfeita.',
        'question', 'danger',
      ).then(result => {
        if (!result || !result.value) return
        this.$isLoading(true)
        api.deletePipelineStage(stage.id).then(() => {
          this.$sucesso('Etapa excluída com sucesso.')
          this.$emit('stage-deleted', stage)
        }).catch(err => {
          this.$erro(err?.response?.data?.detail || 'Erro ao excluir etapa, tente novamente mais tarde.')
        }).finally(() => {
          this.$isLoading(false)
        })
      })
    },
    async onDealChanged(stage, changeEvt) {
      try {
        if (changeEvt && changeEvt.added) {
          const { element, newIndex } = changeEvt.added
          const deal = element
          const targetStageId = stage.id
          this.$isLoading(true)
          await api.updateDeal(deal.id, targetStageId, newIndex + 1)
          this.$sucesso('Oportunidade movida com sucesso.')
        } else if (changeEvt && changeEvt.moved) {
          const { element, newIndex } = changeEvt.moved
          const deal = element
          this.$isLoading(true)
          await api.updateDeal(deal.id, stage.id, newIndex + 1)
          this.$sucesso('Ordem atualizada com sucesso.')
        }
      } catch {
        this.$erro('Erro ao atualizar a oportunidade. Tente novamente.')
        this.carregarFunisEtapasOportunidades()
      } finally {
        this.$isLoading(false)
      }
    },
  },
}
</script>
